<template>
  <select-button
    v-model="internalSelectedID"
    :options="options"
    :size="size"
    :is-disabled="isDisabled"
    title="Priority"
  >
    <template #prefix>
      <img v-if="!hideIcon" :src="selectedIcon" class="prefix-icon">
    </template>
  </select-button>
</template>

<script lang="ts">
/* General */
import { defineComponent } from 'vue'
import LowIcon from '@/assets/img/priority/low.svg'
import MediumIcon from '@/assets/img/priority/medium.svg'
import HighIcon from '@/assets/img/priority/high.svg'
import CriticalIcon from '@/assets/img/priority/critical.svg'

/* Mixins */

/* Components */

/* Helpers */

/* Data types */
import { IDynamicObject } from '@/types'
import { IPriorityLevelForSelection } from '@/api/types/response.types'

/* API */

export default defineComponent({
  name: 'PriorityPicker',

  props: {
    selectedId: {
      type: Number,
      default: null,
    },
    options: {
      type: Array as () => IPriorityLevelForSelection[],
      default: (): IPriorityLevelForSelection[] => [],
    },
    hideIcon: {
      type: Boolean,
      default: false,
    },
    size: {
      type: String,
      default: 'small',
    },
    isDisabled: {
      type: Boolean,
      default: false,
    },
  },

  emits: ['update:selectedId'],

  computed: {
    internalSelectedID: {
      get(): number {
        return this.selectedId
      },
      set(newValue: number) {
        this.$emit('update:selectedId', newValue)
      },
    },
    iconStatusList(): IDynamicObject {
      return {
        low: LowIcon,
        medium: MediumIcon,
        high: HighIcon,
        critical: CriticalIcon,
      }
    },
    selectedIcon(): string {
      /* Note: select-button will default its value to 'low' as well */
      if (this.selectedId === null) {
        return LowIcon
      }
      const selectedPriority = this.options.find(
        item => item.id === this.selectedId,
      )

      return this.iconStatusList[selectedPriority.name.toLowerCase()]
    },
    selectedName(): string {
      if (this.selectedId === null) {
        return
      }
      return this.options.find(item => item.id === this.selectedId).name
    },
  },
})
</script>
